import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '../shared/Icon';
import { IconButton } from './Button';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
`;
const Message = styled.div`
  margin-top: 20px;
  max-width: 80%;
  text-align: center;
  font-size: 1.5em;
`;

interface IProps {
  message: string;
  filterApplied?: boolean;
  clearFilter?: () => void;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const NoResults = ({
  message,
  filterApplied,
  clearFilter,
  children,
  style,
}: IProps): React.ReactElement => {
  return (
    <Container style={style}>
      <Icon name='error_outline' size='medium' />
      <Message>{message}</Message>
      {filterApplied && (
        <IconButton
          onClick={clearFilter}
          icon='clear'
          title='Clear Filter'
        />
      )}
      {children}
    </Container>
  );
};

export { NoResults };
